import { Button, Flex, PinInput, Text } from "@gravity-ui/uikit";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import { appConfig } from "src/config";
import { RoutesPaths } from "src/routes/RoutesPaths";

import { useVerification } from "./hooks/useVerification";
import css from "./VerifyPage.module.scss";

export const VerifyPage = () => {
  const navigate = useNavigate();
  const { email, code, setCode, accountVerify, resendCode, isLoading } =
    useVerification();

  return (
    <Flex className={cn(css.main, css.full)}>
      <Flex className={cn(css.main, css.mainContainer)}>
        <Flex className={css.main}>
          <appConfig.logo
            height={50}
            onClick={() => navigate(RoutesPaths.LANDING)}
            className={css.footerLogo}
          />
          <Text variant="display-1">Верификация</Text>
          <Text
            variant="body-1"
            style={{ maxWidth: 280, textAlign: "center", marginTop: 6 }}
          >
            Код верификации отправлен на вашу почту {email}
          </Text>
        </Flex>
        <div className={css.regForm}>
          <PinInput
            size="xl"
            value={code?.split("") || []}
            onUpdate={(value) => setCode(value.toString().replace(/,/g, ""))}
          />

          <Flex
            className={css.regFormInputContainer}
            direction={"column"}
            alignItems={"center"}
            gap={"3"}
          >
            <Button
              className={css.regButton}
              view="action"
              size="l"
              width="max"
              loading={isLoading}
              onClick={() => accountVerify(code, email)}
            >
              Подтвердить
            </Button>
            <Flex gap={1}>
              <Text color="secondary">Не пришел код?</Text>
              <Text className={css.linkLabel} onClick={() => resendCode(email)}>
                Повторить отправку
              </Text>
            </Flex>
          </Flex>
        </div>
      </Flex>
    </Flex>
  );
};
